import HowToHeader from '../HowToHeader';

// Images
import img1 from './Image 1.png';
import img2 from './Image 2.png';
import img3 from './Image 3.png';
import img4 from './Image 4.png';
import img5 from './Image 5.png';
import img6 from './Image 6.png';
import img7 from './Image 7.png';
import img8 from './Image 8.png';
import img9 from './Image 9.png';
import img10 from './Image 10.png';

// Header
const headerText = `Applying for a Registration Number`;

const ApplyingForRegistrationNumber = () => {
  return (
    <>
      <HowToHeader titleText={headerText} />
      <p>
        Click “Apply for a Registration Number” under the “My Applications”
        section.
      </p>
      <div className='text-center'>
        <img className='img-fluid' src={img1} alt='Image 1' />
      </div>
      <p>
        Follow the four steps, shown across four tabs, to complete this
        application. Please note you have the ability to clear a step or all
        steps at the bottom of the tab window.
      </p>
      <p>
        Step 1 allows you to choose the default email that appears (which
        matches the one you used to create the account). To enter a different
        email of your choice, move to the “Other” option, type in the new
        address, and click “Save & Continue.”
      </p>
      <div className='text-center'>
        <img className='img-fluid' src={img2} alt='Image 2' />
      </div>
      <p>
        Please note that all status updates related to this application will go
        to the email address chosen during Step 1.
      </p>
      <p>
        Step 2 is where you provide the Shared Housing Unit Address. The
        previously entered address will automatically populate, but you can also
        use the “Use new address” option to enter a different one. Hit “Save &
        Continue” to move to the Step 3 tab.
      </p>
      <div className='text-center'>
        <img className='img-fluid' src={img3} alt='Image 3' />
      </div>
      <p>
        Step 3 is where you identify your Relationship to Property. Verify that
        the address is correct. Then use the dropdown list to confirm which
        option applies to you.
      </p>
      <div className='text-center'>
        <img className='img-fluid' src={img4} alt='Image 4' />
      </div>
      <p>
        This is also where you will confirm whether or not this is your primary
        residence. If so, you will be required to upload two forms of proof. The
        file size of this document must be greater than 1 KB and less than 5 MB.
      </p>
      <div className='text-center'>
        <img className='img-fluid' src={img5} alt='Image 5' />
      </div>
      <p>
        Once the documents are uploaded, if the type and file size are correct,
        you will see confirmation of uploaded documents in the green box. Click
        “Save & Continue” to move to the Step 4 tab.
      </p>
      <div className='text-center'>
        <img className='img-fluid' src={img6} alt='Image 6' />
      </div>
      <p>
        Step 4 is where you enter all additional information that BACP needs to
        gather for your application. This includes identifying the platforms on
        which you plan to list your property and the dwelling type. If the
        address is a partial dwelling, please answer the additional items
        related to this classification.
      </p>
      <p>
        <strong>
          Note: Maximum number of sleeping rooms used for shared housing is 6,
          regardless of total number of sleeping rooms in unit.
        </strong>
      </p>
      <div className='text-center'>
        <img className='img-fluid' src={img7} alt='Image 7' />
      </div>
      <p>
        Once you’ve entered all of your information, click “Review Application.”
      </p>
      <p>
        An error message will appear inside of a red box if any information is
        incorrect, notifying you of what these items are so you can proceed
        accordingly.
      </p>
      <div className='text-center'>
        <img className='img-fluid' src={img8} alt='Image 8' />
      </div>
      <p>
        Confirm the information in your application is accurate and complete by
        clicking the checkbox and then “Submit” button.
      </p>
      <div className='text-center'>
        <img className='img-fluid' src={img10} alt='Image 10' />
      </div>
      <p>
        If the application has all of the proper details, click submit and you
        will see this message that confirms the application has been submitted.
        No further action is required.
      </p>
      <div className='text-center'>
        <img className='img-fluid' src={img9} alt='Image 9' />
      </div>
    </>
  );
};

export default ApplyingForRegistrationNumber;
